import {RouteContext} from "../../RouteContext";
import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../../common/DetailPage";
import {PlacePathBrowserValueObject} from "../../../../model/vo/content/place/PlacePathBrowserValueObject";
import {PlacePathBrowserIO} from "../../../../io/content/place/PlacePathBrowserIO";
import {Column} from "../../common/Layout";
import {ListPage} from "../../common/ListPage";
import {ShoppingPathValueObject} from "../../../../model/vo/content/ShoppingPathValueObject";
import {ShoppingPathIO} from "../../../../io/content/ShoppingPathIO";
import {
    Button,
    Dialog,
    DialogBody, DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger, makeStyles,
    Switch
} from "@fluentui/react-components";
import TruncateText from "../../common/TruncateText";
import {PlaceVisibilityName} from "../../../../constant/Visibility";
import {BitMask} from "../../../../utils/bitmask";
import {useStatePair} from "../../../../type/States";
import {PlaceMissionType} from "../../../../constant/PlaceMissionType";

const propertyDetail: DetailPagePropertyIndicator<PlacePathBrowserValueObject> = {}

type Panel = DetailPagePanelConstraint | 'PlacePath';

const panelDescription: Record<Panel, string> = {
    Main: '기본',
    PlacePath: '플레이스경로'
};

export default function Detail(props: RouteContext) {
    const isActiveState = useStatePair<Map<bigint, boolean>>(new Map<bigint, boolean>())

    const setActive = (id: bigint, isActive: boolean) => {
        const acc = new Map<bigint, boolean>(isActiveState.value)
        acc.set(id, isActive)
        isActiveState.setValue(acc)
    }

    const panelDetail: DetailPagePanelIndicator<PlacePathBrowserValueObject, Panel> = {
        PlacePath: (props: RouteContext, item: PlacePathBrowserValueObject): JSX.Element => <>
            <Column gap={'16px'}>
                <ListPage
                    {...props}
                    description={ShoppingPathValueObject.description}
                    list={ShoppingPathIO.list}
                    count={ShoppingPathIO.count}
                    delete={ShoppingPathIO.delete}
                    postHref={'/admin/shoppings/paths/post'}
                    detailHref={item => `/admin/shoppings/paths/${item.id}`}
                    editHref={item => `/admin/shoppings/paths/edit/${item.id}`}
                    itemValue={(item, key) => {
                        if (key === 'isActive') {
                            const present = isActiveState.value.get(item.id)
                            if (present !== undefined) {
                                return <>
                                    <Switch
                                        checked={present}
                                        onChange={(ev, data) => {

                                            const id = Number(item.id.toString().split('n')[0])

                                            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/${id}/state`,
                                                {
                                                    method: 'PATCH',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                    },
                                                    credentials: 'include',
                                                    body: JSON.stringify({
                                                        wishState: data.checked,
                                                    }),
                                                }
                                            )
                                                .then(async value => {
                                                    const res = await value.json()
                                                    console.log(res)

                                                    if (!res) {
                                                        return
                                                    }

                                                    setActive(item.id, data.checked)

                                                })
                                        }
                                        }

                                    />
                                </>
                            } else {
                                return <>
                                    <Switch
                                        checked={item.isActive}
                                        onChange={(ev, data) => {

                                            const id = Number(item.id.toString().split('n')[0])
                                            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/paths/${id}/state`,
                                                {
                                                    method: 'PATCH',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                    },
                                                    credentials: 'include',
                                                    body: JSON.stringify({
                                                        wishState: data.checked,
                                                    }),
                                                }
                                            )
                                                .then(async value => {
                                                    const res = await value.json()
                                                    console.log(res)

                                                    if (!res) {
                                                        return
                                                    }

                                                    setActive(item.id, data.checked)

                                                })
                                        }
                                        }/>
                                </>
                            }
                        }
                        else if(key == 'format'){
                            return <TruncateText text={item[key] || ''} maxLength={20}/>
                        }
                        else if(key === 'visibility'){
                            return<>
                                <Dialog modalType="non-modal">
                                    <DialogTrigger disableButtonEnhancement>
                                        <Button>{item.visibility}</Button>
                                    </DialogTrigger>
                                    <DialogSurface>
                                        <DialogBody>
                                            <DialogTitle>보임여부</DialogTitle>
                                            <DialogContent>
                                                {
                                                    PlaceVisibilityName.map((name, idx) => {
                                                        const isVisible = !!(Number(item.visibility) & (1 << idx));
                                                        return (
                                                            <div key={idx} style={isVisible ? { fontWeight: 'bold' } : {}}>
                                                                {name}
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </DialogContent>
                                        </DialogBody>
                                    </DialogSurface>
                                </Dialog>
                            </>
                        }
                        else if(key === 'type') {
                            return<>
                                <Dialog modalType="non-modal">
                                    <DialogTrigger disableButtonEnhancement>
                                        <Button>{item.type}</Button>
                                    </DialogTrigger>
                                    <DialogSurface>
                                        <DialogBody>
                                            <DialogTitle>유형</DialogTitle>
                                            <DialogContent>
                                                {
                                                    PlaceMissionType.map((name, idx) => {
                                                        const isEnabled = BitMask.isEnabled(item.type, idx)
                                                        return (
                                                            <div key={idx} style={isEnabled ? { fontWeight: 'bold' } : {}}>
                                                                {name}
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </DialogContent>
                                        </DialogBody>
                                    </DialogSurface>
                                </Dialog>
                            </>
                        }
                        else {
                            return undefined
                        }
                    }}
                    initialSearchConditions={[
                        {
                            name: 'id',
                            value: String(item.placePathId),
                            condition: 'Equal'
                        },
                        {
                            name: 'deletedAt',
                            value: '',
                            condition: 'IsNull'
                        },
                    ]}
                />
            </Column>
        </>
    };

    return (
        <DetailPage
            {...props}
            propertyDescription={PlacePathBrowserValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={PlacePathBrowserIO.get}
        />
    );
}
